import { useEffect } from "react";
import { useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const cmsData = useSelector(state => state.data.cms);

  useEffect(() => {
    const innovationPath = cmsData?.innovation?.Introduction.Menu.Path;
    if (innovationPath && pathname && pathname.indexOf(`/${innovationPath}`) === 0) {
      return;
    }
    
    window.scrollTo(0, 0);
    document.body.scrollTo(0, 0);
  }, [pathname]);

  return null;
}